import {Router, RouterModule, Routes} from '@angular/router';
import {RegisterComponent} from "./core/authentication/register/register.component";
import {LoginComponent} from "./core/authentication/login/login.component";
import {UserProfileComponent} from "./features/users/user-profile/user-profile.component";
import {canActivate} from "./shared/routing/auth-route-guard.function";
import {ProductListAdminComponent} from "./features/products/admin/product-list/product-list-admin.component";
import {ProductListComponent} from "./features/products/public/product-list/product-list.component";
import {
  ProductDetailAdminComponent
} from "./features/products/admin/product-detail/product-detail-admin.component";
import {DefaultLayoutComponent} from "./layouts/default-layout/default-layout.component";
import {AdminLayoutComponent} from "./layouts/admin-layout/admin-layout.component";
import {NgModule} from "@angular/core";
import {AuthGuard} from "./shared/guards/AuthGuard";
import {PageListAdminComponent} from "./features/pages/admin/page-list/page-list-admin.component";
import {PageDetailAdminComponent} from "./features/pages/admin/page-detail/page-detail-admin.component";
import {PageSettingsComponent} from "./features/pages/admin/page-settings/page-settings.component";
import {SectionListAdminComponent} from "./features/sections/admin/section-list-admin/section-list-admin.component";
import {ProductSettingsComponent} from "./features/products/admin/product-settings/product-settings.component";
import {PriceAdminComponent} from "./features/data-sources/price-admin/price-admin.component";
import {DataSourceListComponent} from "./features/data-sources/data-source-list/data-source-list.component";
import {PageListComponent} from "./features/pages/public/page-list/page-list.component";
import {PageDetailComponent} from "./features/pages/public/page-detail/page-detail.component";
import {BenchmarkComponent} from "./features/benchmarks/admin/benchmark/benchmark.component";
import {PeriodSelectComponent} from "./features/periods/admin/period-select/period-select.component";
import {
  ProductDetailComponent
} from "./features/products/public/product-detail/product-detail.component";
import {DataSourceDetailComponent} from "./features/data-sources/data-source-detail/data-source-detail.component";
import {CategoryListAdminComponent} from "./features/categories/admin/category-list/category-list-admin.component";
import {
  CategoryDetailAdminComponent
} from "./features/categories/admin/category-detail/category-detail-admin.component";
import {CategorySettingsComponent} from "./features/categories/admin/category-settings/category-settings.component";
import {CategoryProductsComponent} from "./features/categories/admin/category-products/category-products.component";
import {PeriodListAdminComponent} from "./features/periods/admin/periods-list-admin/period-list-admin.component";
import {MediaListComponent} from "./features/media-library/media-list/media-list.component";
import {PhaseListComponent} from "./features/phases/phase-list/phase-list.component";
import {AllocationListComponent} from "./features/allocations/allocation-list/allocation-list.component";
import {AllocationDetailComponent} from "./features/allocations/allocation-detail/allocation-detail.component";
import {ReportListComponent} from "./features/reports/admin/report-list/report-list.component";
import {LoginPasswordComponent} from "./core/authentication/login-password/login-password.component";
import {PasswordForgotComponent} from "./core/authentication/password-forgot/password-forgot.component";
import {PasswordResetComponent} from "./core/authentication/password-reset/password-reset.component";
import {AdminGuard} from "./shared/guards/AdminGuard";
import {UserListComponent} from "./features/users/user-list/user-list.component";

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {path: '', component: ProductListComponent},
      {path: 'login', component: LoginPasswordComponent},
      {path: 'register', component: RegisterComponent},
      {path: 'password-forgot', component: PasswordForgotComponent},
      {path: 'password-reset', component: PasswordResetComponent},
      {path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuard] },
      {path: 'products', component: ProductListComponent},
      {
        path: 'products/:productSlug', component: ProductDetailComponent,
        children: [
          {path: '', redirectTo: 'overview', pathMatch: 'full'},
          {path: ':pageSlug', component: PageDetailComponent},
        ]
      }
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      {path: 'products', component: ProductListAdminComponent},
      {path: 'analysis-periods', component: PeriodListAdminComponent},
      {path: 'media-library', component: MediaListComponent},
      {path: 'users', component: UserListComponent},
      {
        path: 'products/:productId',
        component: ProductDetailAdminComponent,
        children: [
          {path: '', redirectTo: 'settings', pathMatch: 'full'},
          {path: 'settings', component: ProductSettingsComponent},
          {path: 'pages', component: PageListAdminComponent},
          {path: 'benchmarks', component: BenchmarkComponent},
          {path: 'allocations', component: AllocationListComponent},
          {path: 'reports', component: ReportListComponent},
          {path: 'analysis-periods', component: PeriodSelectComponent},
          {path: 'phases', component: PhaseListComponent},
          {path: 'data-source', component: DataSourceListComponent},
          {path: 'data-source/price-data', component: PriceAdminComponent},
        ]
      },
      {
        path: 'products/:productId/pages/:pageId',
        component: PageDetailAdminComponent,
        children: [
          {path: '', redirectTo: 'settings', pathMatch: 'full'},
          {path: 'settings', component: PageSettingsComponent},
          {path: 'sections', component: SectionListAdminComponent},
        ]
      },
      {path: 'products/:productId/data-source/:dataSourceId', component: DataSourceDetailComponent},
      {path: 'products/:productId/allocations/:allocationId', component: AllocationDetailComponent},
      {path: 'categories', component: CategoryListAdminComponent},
      {
        path: 'categories/:categoryId',
        component: CategoryDetailAdminComponent,
        children: [
          {path: '', redirectTo: 'settings', pathMatch: 'full'},
          {path: 'settings', component: CategorySettingsComponent},
          {path: 'products', component: CategoryProductsComponent},
        ]
      },
    ]
  },
  //{path: 'login', component: LoginPasswordComponent},
  //{path: 'register', component: RegisterComponent},
  //{path: 'login', component: LoginComponent, canActivate: [canActivate]},
  //{path: 'register', component: RegisterComponent, canActivate: [canActivate]},
  //{path: 'user-profile', component: UserProfileComponent, canActivate: [canActivate]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
